import {gsap} from 'gsap';

//under development
export default function () {
  const wrapSelector = '.js-page-preview';
  const btnSelector = '.js-page-preview-btn';
  const contentSelector = '.js-page-preview-content';
  const iframeSelector = '.js-page-preview-iframe';
  const formSelector = '.js-page-preview-form';

  const showClass = 'page-preview_show';

  const wrapper = document.querySelector(wrapSelector);
  // const form = document.querySelector(formSelector);

  if (!wrapper) return;

  wrapper.addEventListener('click', (e) => {
    const btn = e.target.closest(btnSelector);
    if (!btn) return;

    e.preventDefault();

    const content = wrapper.querySelector(contentSelector);
    const iframe = wrapper.querySelector(iframeSelector);

    if (!iframe || !content) return;

    if (wrapper.classList.contains(showClass)) {
      wrapper.classList.remove(showClass);
      btn.textContent = btn.getAttribute('data-show-text');

      gsap.to(content, {height: 0});
    } else {
      wrapper.classList.add(showClass);
      btn.textContent = btn.getAttribute('data-hide-text');

      gsap.set(content, {height: 'auto'});
      gsap.from(content, {height: 0});

      if (!iframe.hasAttribute('src')) {
        iframe.setAttribute('src', iframe.getAttribute('data-url'));
      }
    }
  });

  /*form.addEventListener('change', () => {
    if (!wrapper.classList.contains(showClass)) return;

    const iframe = wrapper.querySelector(iframeSelector);
    if (!iframe) return;

    iframe.setAttribute('src', iframe.getAttribute('data-url'));
  });*/
}
